<template>
  <div
    class="large-category-widget"
    id="tour-01001-step2">
    <h4>分類</h4>
    <v-card
      variant="flat"
      rounded="0">
      <v-list
        lines="one">
        <v-list-item
          :key="999"
          :to="{ name: 'items' }">
          <template v-slot:title>すべて</template>
          <template v-slot:prepend>
            <v-icon icon="mdi-menu-right"></v-icon>
          </template>
        </v-list-item>
        <v-list-item
          v-for="(item, i) in largeCategories"
          :key="i"
          :to="{ name: 'large_category', params: { largeCategoryCd: item?.largeCd } }">
          <template v-slot:title>{{item.name}}</template>
          <template v-slot:prepend>
            <v-icon icon="mdi-menu-right"></v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, toRefs, watch, computed } from 'vue'
import * as api from '@/api/okaso-api'
import { useSearchLargeCategoriesFunc } from '@/services/searchLargeCategories'
import { useUrlFunc } from '@/utils/url';

const url = useUrlFunc()

interface Props {
  largeCategoryCd?: number;
}

const props = withDefaults(defineProps<Props>(), {
  largeCategoryCd: undefined,
})
const { largeCategoryCd } = toRefs(props);
const largeCategories = ref<api.LargeCategory[]>()

interface Emits {
  (e: 'update:selectedLargeCategory', largeCategoryComputed?: api.LargeCategory): void,
}
const emits = defineEmits<Emits>();

// 大分類取得 ------------------
const {
  searchLargeCategories,
  searchLargeCategoriesOnError,
  searchLargeCategoriesOnResult
} = useSearchLargeCategoriesFunc()

searchLargeCategoriesOnError((error) => {
  console.log(error.message)
  url.show500(error.message)
})

searchLargeCategoriesOnResult((result) => {
  if (result.data?.largeCategories || result.data?.largeCategories.length > 0) {
    largeCategories.value = result.data?.largeCategories as api.LargeCategory[]
  } else {
    largeCategories.value = []
  }
})
// ------------------------------

// 大分類
const largeCategoryComputed = computed(() => {
  return !!largeCategoryCd.value ? largeCategories.value?.find((largeCategory)=>{return largeCategory.largeCd == largeCategoryCd.value}):undefined
})

onMounted(() => {
  searchLargeCategories({})
})

watch( largeCategoryComputed, () => {
  emits('update:selectedLargeCategory', largeCategoryComputed.value? largeCategoryComputed.value: undefined)
})

</script>

<style lang="scss" scoped>
  .large-category-widget {
    max-width: 200px;
    border-radius: 10px 10px 0 0;

    &::v-deep(h4) {
      font-weight: 700;
      font-size: 1.2rem;
      color: rgb(var(--v-theme-white));
      background: rgb(var(--v-theme-green-01));
      padding: 8px 10px;
      border-radius: 10px 10px 0 0;
    }

    .v-list {
      padding: 0;
      background: rgb(var(--v-theme-green-03));
    }

    &::v-deep(.v-list-item) {
      padding-left: 8px;
      padding-right: 8px;

      .v-list-item__prepend>.v-icon {
        margin-right: 0;
        width: 16px;
      }
    }

    &::v-deep(.v-list-item__content) {
      display: flex;
      align-items: center;
    }

    &::v-deep(.v-list-item-title) {
      display: inline-block;
      color: rgb(var(--v-theme-black));
      opacity: 1;
    }

    &::v-deep(.v-list-item-subtitle) {
      color: rgb(var(--v-theme-black));
      opacity: 1;
      line-height: 1.6;
    }

    &::v-deep(.v-list-item--active) {
      .v-list-item__overlay {
        opacity: 0;
      }

      .v-list-item-title {
        font-weight: 700;
      }

      .v-list-item__content,
      .v-icon {
        position: relative;

        &::after {
          position: absolute;
          bottom: 0;
          left: 0;
          display: block;
          content: "";
          width: 100%;
          height: 1px;
          background: #55C0ED;
        }
      }

      .mdi-menu-right::before {
        color: #55C0ED;
      }
    }
  }

</style>
